import { useState, useRef } from 'react';
import './BottomNav.css';

const BottomNav = ({ activeTab, onTabChange }) => {
  const tabs = ['history', 'play', 'stats'];
  const activeIndex = tabs.indexOf(activeTab);
  const [isMoving, setIsMoving] = useState(false);
  const highlightRef = useRef(null);

  const handleTabChange = (tab) => {
    if (tab !== activeTab) {
      setIsMoving(true);
      onTabChange(tab);
    }
  };

  const handleTransitionEnd = (e) => {
    if (e.propertyName === 'transform') {
      setIsMoving(false);
    }
  };

  return (
    <nav className="bottom-nav">
      <div 
        ref={highlightRef}
        className="nav-highlight"
        onTransitionEnd={handleTransitionEnd}
        style={{
          transform: `translateX(${activeIndex * 62}px) scaleX(${isMoving ? 0.9 : 1}) scaleY(${isMoving ? 1.05 : 1})`,
        }}
      />
      <NavItem
        active={activeTab === 'history'}
        onClick={() => handleTabChange('history')}
      >
        <HistoryIcon />
      </NavItem>
      <NavItem
        active={activeTab === 'play'}
        onClick={() => handleTabChange('play')}
      >
        <PlayIcon />
      </NavItem>
      <NavItem
        active={activeTab === 'stats'}
        onClick={() => handleTabChange('stats')}
      >
        <StatsIcon />
      </NavItem>
    </nav>
  );
};

const NavItem = ({ active, onClick, children }) => (
  <button
    onClick={onClick}
    className={`nav-item ${active ? 'active' : ''}`}
  >
    <div className="nav-icon">
      {children}
    </div>
  </button>
);

const PlayIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="5 3 19 12 5 21 5 3" />
  </svg>
);

const HistoryIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 12a9 9 0 1 0 3-6.7L3 8" />
    <path d="M3 3v5h5" />
    <path d="M12 7v5l3 2" />
  </svg>
);

const StatsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10" />
    <line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
  </svg>
);

export default BottomNav;
